<template>
  <div class="accessad-page">
    <tableComponents
      ref="tableComponents"
      :pagination="{
        currentPage: paginationForm.page,
        pageSize: paginationForm.page_size,
        total,
      }"
      :searchData="accessadSearchData"
      :isHaveExport="false"
      :isHaveAdd="false"
      :sizes="[10, 20, 50, 100]"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
      @sendUserSearch="getSearch"
    >
      <template #table>
        <AccessadTable :list="list" :loading="loading" />
      </template>
    </tableComponents>
  </div>
</template>

<script>
import AccessadTable from "./components/AccessadTable.vue";

function createDefaultQueryForm() {
  return {
    page_size: 20,
    user_id: "",
    trans_id: "",
    ad_tag: "",
    name: "",
    accounting: "",
    mediation_rit: "",
    prime_rit: "",
    type: "",
    start_time: "",
    end_time: "",
  };
}

export default {
  components: {
    AccessadTable,
  },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      hasMore: true,
      queryForm: createDefaultQueryForm(),
      paginationForm: {
        page: 1,
        page_size: 20,
      },
      pageCursorMap: {
        1: 0,
      },
      fetchedPageMap: {},
    };
  },
  computed: {
    accessadSearchData() {
      return () => [
        {
          title: "",
          type: "1",
          data: [
            {
              type: "date",
              arr: [],
              key: ["start_time", "end_time"],
              placeholder: "回调时间",
            },
          ],
        },
        {
          title: "",
          type: "2",
          data: [
            { type: "text", key: "user_id", placeholder: "搜索用户ID" },
            { type: "text", key: "trans_id", placeholder: "搜索 Trans ID" },
            { type: "text", key: "ad_tag", placeholder: "搜索广告标签" },
            { type: "text", key: "name", placeholder: "搜索广告名称" },
            { type: "text", key: "mediation_rit", placeholder: "搜索 Mediation RIT" },
            { type: "text", key: "prime_rit", placeholder: "搜索 Prime RIT" },
            {
              type: "select",
              key: "accounting",
              option: [
                { id: "1", title: "已分佣" },
                { id: "0", title: "分佣失败" },
              ],
              placeholder: "分佣状态",
              onChange: () => {},
            },
            {
              type: "select",
              key: "type",
              option: [
                { id: "奖励", title: "奖励" },
                { id: "插屏", title: "插屏" },
                { id: "开屏", title: "开屏" },
                { id: "信息流", title: "信息流" },
              ],
              placeholder: "广告类型",
              onChange: () => {},
            },
          ],
        },
      ];
    },
  },
  methods: {
    resetCursorState() {
      this.pageCursorMap = { 1: 0 };
      this.fetchedPageMap = {};
      this.hasMore = true;
      this.total = 0;
      this.list = [];
    },
    getEffectiveParams() {
      const params = {
        ...this.queryForm,
        page_size: this.paginationForm.page_size,
        last_id: this.pageCursorMap[this.paginationForm.page] || 0,
      };

      if (this.$route.query.user_id && !params.user_id) {
        params.user_id = this.$route.query.user_id;
      }

      return params;
    },
    async ensureCursorForPage(page) {
      if (page <= 1 || this.pageCursorMap[page] !== undefined) {
        return true;
      }

      let currentPage = 1;
      while (currentPage < page) {
        if (this.pageCursorMap[currentPage + 1] !== undefined) {
          currentPage += 1;
          continue;
        }

        if (!this.hasMore) {
          return false;
        }

        const params = {
          ...this.queryForm,
          page_size: this.paginationForm.page_size,
          last_id: this.pageCursorMap[currentPage] || 0,
        };

        if (this.$route.query.user_id && !params.user_id) {
          params.user_id = this.$route.query.user_id;
        }

        const data = await this.$api.getAccessad.getAccessadList(params);
        const nextList = data.data && data.data.list ? data.data.list : [];
        const hasMore = Boolean(data.data && data.data.has_more);
        const nextLastId = data.data && data.data.last_id ? data.data.last_id : 0;

        this.fetchedPageMap[currentPage] = nextList;
        this.hasMore = hasMore;
        this.total = hasMore
          ? Math.max(this.total, (currentPage + 1) * this.paginationForm.page_size)
          : currentPage * this.paginationForm.page_size + nextList.length;

        if (hasMore && nextList.length) {
          this.pageCursorMap[currentPage + 1] = nextLastId;
        } else {
          this.pageCursorMap[currentPage + 1] = nextLastId || 0;
        }

        currentPage += 1;
      }

      return true;
    },
    async getAccessadList() {
      this.loading = true;
      try {
        const page = this.paginationForm.page;
        if (page > 1) {
          const ok = await this.ensureCursorForPage(page);
          if (!ok) {
            this.list = [];
            return;
          }
        }

        if (this.fetchedPageMap[page]) {
          this.list = this.fetchedPageMap[page];
          return;
        }

        const data = await this.$api.getAccessad.getAccessadList(this.getEffectiveParams());
        const nextList = data.data && data.data.list ? data.data.list : [];
        this.hasMore = Boolean(data.data && data.data.has_more);
        const nextLastId = data.data && data.data.last_id ? data.data.last_id : 0;
        this.fetchedPageMap[page] = nextList;
        this.list = nextList;

        if (this.hasMore && nextList.length) {
          this.pageCursorMap[page + 1] = nextLastId;
          this.total = Math.max(this.total, (page + 1) * this.paginationForm.page_size);
        } else {
          this.pageCursorMap[page + 1] = nextLastId || 0;
          this.total = (page - 1) * this.paginationForm.page_size + nextList.length;
        }
      } finally {
        this.loading = false;
      }
    },
    handleCurrentChange(page) {
      this.paginationForm.page = page;
      this.getAccessadList();
    },
    handleSizeChange(size) {
      this.paginationForm.page_size = size;
      this.paginationForm.page = 1;
      this.resetCursorState();
      this.getAccessadList();
    },
    getSearch(form) {
      this.queryForm = {
        ...createDefaultQueryForm(),
        ...form,
      };
      this.paginationForm.page = 1;
      this.resetCursorState();
      this.getAccessadList();
    },
  },
  created() {
    if (this.$route.query.user_id) {
      this.queryForm.user_id = this.$route.query.user_id;
    }
    this.getAccessadList();
  },
  watch: {
    $route() {
      this.queryForm = createDefaultQueryForm();
      if (this.$route.query.user_id) {
        this.queryForm.user_id = this.$route.query.user_id;
      }
      this.paginationForm.page = 1;
      this.resetCursorState();
      this.getAccessadList();
    },
  },
};
</script>
